import React, { useState } from 'react';
import useSWR from 'swr';
import api from '~/_base/constants/api';
import {
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  ListItemIcon,
  InputBase,
} from '@mui/material';
import { ICross2 } from './helixIcons';
import { useTranslation } from 'react-i18next';

export default function ProjectMenu() {
  const { data: currentContext } = useSWR(
    api.currentContext.address,
    api.currentContext.request
  );
  const isProjectSelected = currentContext?.current_project != null;
  const { data } = useSWR(api.projects.address, api.projects.request);
  const projects = data || [];
  const [searchValue, setSearchValue] = useState('');
  const { t } = useTranslation();

  function parseData() {
    const filteredProjects = projects.filter(i => {
      const concatenatedName =
        i.job_number.toLowerCase() + ' ' + i.name.toLowerCase();

      if (concatenatedName.indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      return false;
    });

    if (filteredProjects.length > 0) {
      var collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'base',
      });
      filteredProjects.sort((a, b) => {
        let A = a['job_number'];
        let B = b['job_number'];
        return collator.compare(A, B);
      });
    }

    return filteredProjects;
  }

  const filteredProjects = parseData();
  const showSearch = projects.length > 10;
  return (
    <div style={{ width: '256px' }}>
      {showSearch && (
        <div style={{padding: 16}}>
          <InputBase
            placeholder={t('Search Projects...')}
            sx={{width: '100%'}}
            value={searchValue}
            type="search"
            onChange={e => setSearchValue(e.target.value)}
          />
          {filteredProjects.length === 0 && (
            <List>
              <ListItem>
                <ListItemText primary={t('No projects found')} />
              </ListItem>
            </List>
          )}
        </div>
      )}
      <List>
        {filteredProjects.map((item, index) => {
          const projectText =
            item.job_number == null ? '' : item.job_number + ' : ' + item.name;
          return (
            <ListItemButton
              key={index}
              onClick={() =>
                (document.location.href = '/?project[id]=' + item.id)
              }
            >
              <ListItemText 
                primary={projectText} 
                sx={{ 
                  '& .MuiListItemText-primary': {
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                  }
                }}
              />
            </ListItemButton>
          );
        })}
        {isProjectSelected && (
          <ListItemButton
            onClick={() => (document.location.href = '/?project[id]=')}
          >
            <ListItemIcon>
              <ICross2 />
            </ListItemIcon>
            <ListItemText primary={t('Clear project selection')} />
          </ListItemButton>
        )}
      </List>
    </div>
  );
}
